export default __webpack_public_path__ + "static/media/131.ebce369c.png";